module.exports = __webpack_public_path__ + "img/ctn_logo_white.2ad6646b.svg";